import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const FOLLOW_UP: AppRouteRecordRaw = {
  path: '/follow-up-management',
  name: 'FollowUpManagement',
  component: DEFAULT_LAYOUT,
  // redirect: '/follow-up-management/today',
  meta: {
    locale: 'menu.followUpManagement',
    requiresAuth: true,
    icon: 'icon-thunderbolt',
    order: 2,
    // hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'today',
      name: 'Today',
      component: () => import('@/views/follow-up/today/index.vue'),
      meta: {
        locale: 'menu.todayFollowUp',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'expired',
      name: 'Expired',
      component: () => import('@/views/follow-up/expired/index.vue'),
      meta: {
        locale: 'menu.expiredFollowUp',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'records',
      name: 'FollowUpHistory',
      component: () => import('@/views/follow-up/records/records.vue'),
      meta: {
        locale: 'menu.followUpHistory',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default FOLLOW_UP;
